import React from 'react';
import { Grid, GridProps } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles(() =>
  createStyles({
    maximizeouticonContainer: {
      height: '20px',
      '&:hover': {
        // background: '#e3e9e5',
      },
    },
    maximizeouticon: {
      width: '35px',
      background: '#828282',
      height: '3px',
      margin: 'auto',
      borderRadius: '5px',
      marginBottom: '11px',
      display: 'block',
    },
  })
);

const MaximizeouticonButton = (props: GridProps) => {
  const classes = useStyles();
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className={classes.maximizeouticonContainer}
      {...props}
    >
      <Grid item xs>
        <span className={classes.maximizeouticon} style={{ marginBottom: 0, display: 'flex' }} />
      </Grid>
    </Grid>
  );
};

export default MaximizeouticonButton;
